import type { ReactNode } from "react";

export interface FieldGridCellProps {
  label: string;
  value: ReactNode;
}

/**
 * A single label-above-value cell, designed to live inside a CSS grid
 * (e.g. `grid-cols-2 md:grid-cols-4`). Use when you want a multi-column
 * field layout — for label-left/value-right stacks, prefer FieldList.
 */
export function FieldGridCell({ label, value }: FieldGridCellProps) {
  return (
    <div>
      <dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className="mt-0.5 text-sm text-foreground">{value}</dd>
    </div>
  );
}
